<template>
  <form
    name="productsearch"
    class="form-search"
    method="get"
    action="/"
    role="search"
    aria-label="Product search"
  >
    <div class="gd-searh__input-wrap">
      <input type="hidden" name="rf" value="kw" />
      <input
        class="gd-searh__input ajax_search"
        value=""
        id="name_search"
        placeholder="Search by keyword"
        autocomplete="off"
        name="kw"
        type="text"
        aria-label="Input search"
      />
      <button
        type="submit"
        value="Search"
        class="gd-searh__btn"
        aria-label="Search site"
      >       
        <svg>
          <use xlink:href="#search-light"></use>
        </svg>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: "neto-search",
  mounted() {
    $.initSearchField({
      result_header: '<ul class="nav nav-list">',
      result_body:
        '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
      result_footer: "</ul>",
      category_header: '<ul class="nav nav-list">',
      category_body:
        '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
      category_footer: "</ul>",
    });
  },
};
</script>
